const BASE_URL = process.env.REACT_APP_API

// user-data
const CREATE_USER_URL = BASE_URL + "/users/create_user"
const LOGIN_URL = BASE_URL + "/users/login_with_email"
const LOGOUT_URL = BASE_URL + "/users/logout"
const CREATE_MFA_URL = BASE_URL + "/users/create_mfa"
const VALIDATE_MFA_URL = BASE_URL + "/users/validate_mfa"
const AGENCY_SETTINGS_UPDATE_URL = BASE_URL + "/users/update_agency_settings"
const GET_USER_AGENCIES_URL = BASE_URL + "/users/get_user_agencies"
const GET_ALL_TEST_METADATA_URL = BASE_URL + "/users/get_all_test_metadata"

const STORE_CUSTOMER_FORM = BASE_URL + "/public/store_customer_form"
const SEND_CONTACT_EMAIL = BASE_URL + "/public/send_contact_email"

const GET_SEVERAL_REPORTS = BASE_URL + "/reports/get_several_reports"
const GET_SEVERAL_REPORTS_FILTERED = BASE_URL + "/reports/get_several_reports_filtered"
const GET_SEVERAL_REPORTS_MEASURES_FILTERED = BASE_URL + "/reports/get_several_reports_measures_filtered"
const GET_SEVERAL_REPORTS_ANALYTICS_FILTERED = BASE_URL + "/reports/get_several_reports_analytics_filtered"
const GET_SEVERAL_REPORTS_FATIGUE_FILTERED = BASE_URL + "/reports/get_several_reports_fatigue_filtered"
const GET_SEVERAL_REPORTS_GPS_FILTERED = BASE_URL + "/reports/get_several_reports_gps_filtered"
const GET_ONE_REPORT = BASE_URL + "/reports/get_one_report"
const GET_ONE_REPORT_TEST_RESULTS = BASE_URL + "/reports/get_one_report_test_results"
const GET_ONE_REPORT_AI_FLAGS = BASE_URL + "/reports/get_one_report_ai_flags"
const GET_ONE_REPORT_NARRATIVE_SUGGESTIONS = BASE_URL + "/reports/get_one_report_narrative_suggestions"
const GET_ONE_REPORT_SUGGESTIONS = BASE_URL + "/reports/get_one_report_suggestions"
const GET_ONE_REPORT_TIMES = BASE_URL + "/reports/get_one_report_times"
const GET_ONE_REPORT_CHECKS = BASE_URL + "/reports/get_one_report_checks"
const GET_MEASURE_METADATA = BASE_URL + "/reports/get_measure_metadata"
const GET_MEDICS_FOR_USER = BASE_URL + "/reports/get_all_agency_medics"
const GET_REPORT_ID_FROM_ENCRYPTED = BASE_URL + "/users/get_report_id_from_encrypted"
const MARK_REPORT_READ_UNREAD = BASE_URL + "/reports/mark_report_read_unread"
const UPDATE_REPORT_STATUS = BASE_URL + "/reports/update_report_status"
const UPDATE_CHECK_OVERRIDE = BASE_URL + "/reports/update_check_override"
const UPDATE_NARRATIVE_SUGGESTION_RATING = BASE_URL + "/reports/update_narrative_suggestion_rating"
const UPDATE_SUGGESTION_RATING = BASE_URL + "/reports/update_suggestion_rating"
const UPDATE_MEDIC_INFO = BASE_URL + "/reports/update_medic_info"
const UPDATE_SUGGESTION_MEDIC_TEXT = BASE_URL + "/reports/update_suggestion_medic_text"
const UPDATE_NARRATIVE_EDITED = BASE_URL + "/reports/update_narrative_edited"
const UPDATE_PILOT_FEEDBACK = BASE_URL + "/reports/update_pilot_feedback"
const GET_ONE_REPORT_SCHEMATRON = BASE_URL + "/reports/get_one_report_schematron"
const REPROCESS_REPORT = BASE_URL + "/reports/reprocess_report"
const AGENT2_PROTOCOL_ANALYSIS = BASE_URL + "/reports/agent2_protocol_analysis"
const GET_ONE_REPORT_FINDINGS = BASE_URL + "/reports/get_one_report_findings"
const GET_DOCUMENT_RETRIEVAL_FLOW = BASE_URL + "/reports/get_document_retrieval_flow"
const ADD_USER_FINDING = BASE_URL + "/reports/add_user_finding"
const DELETE_USER_FINDING = BASE_URL + "/reports/delete_user_finding"
const VALIDATE_FINDING = BASE_URL + "/reports/validate_finding"
const FLAG_FINDING = BASE_URL + "/reports/flag_finding"

// demo-data
const STORE_DEMO_REPORT = BASE_URL + "/admin/store_demo_report"
const GET_DEMO_REPORTS = BASE_URL + "/admin/get_demo_reports"
const GET_ONE_DEMO_REPORT = BASE_URL + "/admin/get_one_demo_report"
const SUBMIT_DEMO_DATA_URL = BASE_URL + "/submitDemoData"
const CONVERT_XML_TO_JSON_URL = BASE_URL + "/admin/convert_xml_to_json"
const VALIDATE_DEMO_CODE_URL = BASE_URL + "/admin/validate_demo_code"
const UPDATE_DEMO_CODE_USAGE_URL = BASE_URL + "/admin/update_demo_code_usage"

// soap-data
const SUBMIT_DATA_URL = BASE_URL + "/submitData"

const GET_AGENCY_UID_FROM_DEMO_CODE = BASE_URL + "/reports/get_agency_uid_from_demo_code"
const GET_SEVERAL_REPORTS_FOR_AGENCY = BASE_URL + "/reports/get_several_reports_for_agency"

const GET_ALL_AGENCIES = BASE_URL + "/admin/get_all_agencies"

const GET_AGENCY_USERS = BASE_URL + "/admin/get_agency_users"

const LINK_USER_TO_AGENCY = BASE_URL + "/admin/link_user_to_agency"

const EXTRACT_ALL_TRANSCRIPTION_DATA = BASE_URL + "/admin/extract_all_transcription_data"

module.exports = {
    CREATE_USER_URL,
    LOGIN_URL,
    LOGOUT_URL,
    CREATE_MFA_URL,
    VALIDATE_MFA_URL,
    AGENCY_SETTINGS_UPDATE_URL,
    GET_USER_AGENCIES_URL,
    GET_ALL_TEST_METADATA_URL,
    STORE_CUSTOMER_FORM,
    SEND_CONTACT_EMAIL,
    GET_SEVERAL_REPORTS,
    GET_SEVERAL_REPORTS_FILTERED,
    GET_SEVERAL_REPORTS_MEASURES_FILTERED,
    GET_SEVERAL_REPORTS_ANALYTICS_FILTERED,
    GET_SEVERAL_REPORTS_FATIGUE_FILTERED,
    GET_SEVERAL_REPORTS_GPS_FILTERED,
    GET_ONE_REPORT,
    GET_ONE_REPORT_TEST_RESULTS,
    GET_ONE_REPORT_AI_FLAGS,
    GET_ONE_REPORT_NARRATIVE_SUGGESTIONS,
    GET_ONE_REPORT_SUGGESTIONS,
    GET_ONE_REPORT_TIMES,
    GET_ONE_REPORT_CHECKS,
    GET_MEASURE_METADATA,
    GET_MEDICS_FOR_USER,
    GET_REPORT_ID_FROM_ENCRYPTED,
    MARK_REPORT_READ_UNREAD,
    UPDATE_REPORT_STATUS,
    UPDATE_CHECK_OVERRIDE,
    UPDATE_NARRATIVE_SUGGESTION_RATING,
    UPDATE_SUGGESTION_RATING,
    UPDATE_MEDIC_INFO,
    UPDATE_SUGGESTION_MEDIC_TEXT,
    UPDATE_NARRATIVE_EDITED,
    UPDATE_PILOT_FEEDBACK,
    GET_ONE_REPORT_SCHEMATRON,
    REPROCESS_REPORT,
    AGENT2_PROTOCOL_ANALYSIS,
    GET_ONE_REPORT_FINDINGS,
    GET_DOCUMENT_RETRIEVAL_FLOW,
    ADD_USER_FINDING,
    DELETE_USER_FINDING,
    VALIDATE_FINDING,
    FLAG_FINDING,
    STORE_DEMO_REPORT,
    GET_DEMO_REPORTS,
    GET_ONE_DEMO_REPORT,
    SUBMIT_DATA_URL,
    SUBMIT_DEMO_DATA_URL,
    CONVERT_XML_TO_JSON_URL,
    VALIDATE_DEMO_CODE_URL,
    UPDATE_DEMO_CODE_USAGE_URL,
    GET_AGENCY_UID_FROM_DEMO_CODE,
    GET_SEVERAL_REPORTS_FOR_AGENCY,
    GET_ALL_AGENCIES,
    GET_AGENCY_USERS,
    LINK_USER_TO_AGENCY,
    EXTRACT_ALL_TRANSCRIPTION_DATA
}